import {
  SELECT_SYNC_MAPS_CONFIGURATION,
  SELECT_MAP_REQUEST_VIEWER_TAB,
  SELECT_NO_MORE_MAP_REQUEST_TO_FETCH,
  SELECT_MAP_REQUEST_REFRESH_LENGTH
} from "../constants/mapRequest";

export const selectSyncMapsConfiguration = configuration => {
  return {
    type: SELECT_SYNC_MAPS_CONFIGURATION,
    payload: configuration
  };
};

export const selectMapRequestViewerTab = tab => {
  return {
    type: SELECT_MAP_REQUEST_VIEWER_TAB,
    payload: tab
  };
};

export const selectNoMoreMapRequestToFetch = end => ({
  type: SELECT_NO_MORE_MAP_REQUEST_TO_FETCH,
  payload: end
});

export const selectMapRequestRefreshLength = end => ({
  type: SELECT_MAP_REQUEST_REFRESH_LENGTH,
  payload: end
});
